import React,{useState,useRef,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL, CurrencySymbol } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaProcessingNote'
import AuthDenied from '../ErrorPage/denied'

import EditHistoryNotesComponent from './note_edit_history'

export default function EditProcessingNote(props){

  const params = useParams();


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }


  const [state, setState] = useState({
    search_customer:'',
    customer_id:0,
    search_product:'',
    product_id:0,
    quantity:'',
    price:'',
    carriage:'',
    handling_fee:'',
    note:'',
    current_data:{
      customer_id:0,
      product_id:0,
      quantity:'',
      price:'',
      carriage:'',
      handling_fee:'',
      note:'',
    },
    version_data:[]
  });

  function handleSubmitForm(values, props){

    if(parseInt(values.customer_id)==0||parseInt(values.product_id)==0){
      return false;
    }


    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/processing-notes/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='error_exist'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Data Exist',text:'Customer, product and quantity already exist.'}});
        setnotify(true);
        return false;
      }


      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/processing-notes/list');
          },2000);
        }else{
          setTimeout(function() {
            setnotify(false);
            WindowReload();
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }



   /*------------------------------------------------------
      SEARCH CUSTOMER: DETAILS
  -------------------------------------------------------*/
  const [searchCustomer, setSearchCustomer] = useState(false);
  const [dataCustomer, setDataCustomer] = useState([]);

  function SearchCustomerFunction(customer_name){

    if(customer_name==''||customer_name==undefined){
      return false;
    }

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Searching',text:"Search in progress. Please wait..."}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','search_customer');
    formData.append('search_param',customer_name);
    axios.post('/admin/processing-notes/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setDataCustomer(obj);
      setspinner(false);
      setHideAlert1(false);
      if(obj.length==0){
        setSearchCustomer(true);
      }
      


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setspinner(false);
      },3000);
    });
  }


  /*------------------------------------------------------
      SEARCH PRODUCT: DETAILS
  -------------------------------------------------------*/
  const [searchProduct, setSearchProduct] = useState(false);
  const [dataProduct, setDataProduct] = useState([]);

  function SearchProductFunction(search_param){

    if(search_param==''||search_param==undefined){
      return false;
    }

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Searching',text:"Search in progress. Please wait..."}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','search_product');
    formData.append('search_param',search_param);
    axios.post('/admin/processing-notes/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setDataProduct(obj);
      setspinner(false);
      setHideAlert2(false);
      if(obj.length==0){
        setSearchProduct(true);
      }
      


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setspinner(false);
      },3000);
    });
  }



  /*------------------------------------------------------
          Note Details
  -------------------------------------------------------*/
  const [hideAlert1, setHideAlert1] = useState(false);
  const [hideAlert2, setHideAlert2] = useState(false);
  function ProcessingNoteDetails(id){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','note_details');
    formData.append('id',id);
    axios.post('/admin/processing-notes/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj==0){
        WindowLocation('/processing-notes/list');
        return false;
      }

      setHideAlert1(true);
      setHideAlert2(true);
      setDataCustomer(obj.customerData);
      setDataProduct(obj.productData);

      setState({
        ...state,
        id:obj.id,
        search_customer:obj.account_number,
        search_product:obj.product_code,
        customer_id:obj.customer_id,
        product_id:obj.product_id,
        quantity:obj.quantity,
        price:obj.price,
        carriage:obj.carriage,
        handling_fee:obj.handling_fee,
        note:obj.note,
        current_data:{
          customer_id:obj.customer_id,
          product_id:obj.product_id,
          quantity:obj.quantity,
          price:obj.price,
          carriage:obj.carriage,
          handling_fee:obj.handling_fee,
          note:obj.note,
        },
        version_data:obj.version_data
      });


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }





  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('yt2d71v4r8p36qfwe');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
          if(params.id){
            ProcessingNoteDetails(params.id);
          }else{
            WindowLocation('/processing-notes/list');
            return false;
          }
      }

        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {((authPages['view']==0||authPages['adding']==0)&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <Form>
          <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateForm}
            onSubmit={handleSubmitForm}
            >
            {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {
            
            return(
              <div className={values.version_data.length>0?'page-wrapper-full':'page-wrapper-half'}>

                  <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div><h1>Update Processing Note</h1></div>
                        <div>
                          <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
                          <Button className='GreenButton strong' size='tiny' content='Back to Processing Note List' icon='arrow left icon' as="a" href={WindowURL('/processing-notes/list')}/>
                        </div>
                      </div>
                  </div>

                <div className="app-body-wrapper">

                  {/* Layout Column wrapper*/}
                  <div className="layout-one-column">

                      {/* left column*/}
                      <div>

                          <div className="page-form-panel">
                            <div className="page-form-header"><h3>Current Version</h3></div>
                            <div className="page-form-body">

                            <div class="alert-message left error">
                                <div><i class="info circle icon"></i></div>
                                <div><p>Customer, product and other fields with asterisk is required.</p></div>
                            </div>
                            <br/>

                            {/*-----------------------------------------------------
                          SEARCH PANEL For Customer
                        -----------------------------------------------------*/}
                        <div className="search_Panel">
                                <div className="search_Panelbody">

                                    <Form.Group widths="equal">
                                        <Field name="search_customer">
                                            {({ field, form }) => (
                                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <Input {...field} onChange={handleChange} placeholder="Search customer"/>
                                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                              </Form.Field>
                                            )}
                                        </Field>
                                        <Field name="button_param">
                                          {({ field, form }) => (
                                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <Button className='LightGrayButton strong' size='medium' content='Search'  icon='search icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                    SearchCustomerFunction(values.search_customer)
                                                }}/>
                                              </Form.Field>
                                            )}
                                        </Field>
                                    </Form.Group>


                                    {(dataCustomer.length==0&&searchCustomer)&&<div class="alert-message left error" style={{'margin-bottom':'15px'}}>
                                        <div><i class="info circle icon"></i></div>
                                        <div>
                                          <h3 style={{'font-weight':'700'}}>Search result</h3>
                                          <p>(0) result found. Try your search again.</p>
                                        </div>
                                    </div>}


                                    {(dataCustomer.length>0&&!hideAlert1)&&<div class="alert-message left" style={{'margin-bottom':'15px', 'background-color':'#fcfff5', 'color':'#2c662d'}}>
                                        <div>
                                          <h3 style={{'font-weight':'700','color':'#2c662d'}}>({dataCustomer.length}) result{dataCustomer.length>1?"'s":''} found</h3>
                                        </div>
                                    </div>}



                                    {dataCustomer.length>0&&<Table celled compact='very'>
                                      <Table.Header>
                                        <Table.Row verticalAlign='middle'>
                                          <Table.HeaderCell colSpan='2' collapsing style={{'font-weight':'700','background-color':'#f9fafb','color':'#573a08'}}>
                                            <p>Select Customer</p>
                                            {values.customer_id==0&&<div class="alert-message left error">
                                              {/*<div><i className="uil-multiply"></i></div>*/}
                                              <div>
                                                <h3 style={{'color':'#9f3a38'}}>This field is required</h3>
                                              </div>
                                            </div>}
                                          </Table.HeaderCell>
                                        </Table.Row>
                                      </Table.Header>
                                      <Table.Body>
                                      {dataCustomer.map(function(data, key){
                                          return <Table.Row verticalAlign='middle' positive={data.id==values.customer_id} onClick={()=>{
                                                  setFieldValue('customer_id',data.id);
                                              }}>
                                              <Table.Cell style={{'cursor':'pointer','width':'1%'}} collapsing>
                                                {data.id==values.customer_id&&values.customer_id!=0&&<i className='uil-check icon' style={{'color':'#21ba45'}}></i>}
                                              </Table.Cell>
                                              <Table.Cell style={{'cursor':'pointer'}} collapsing>
                                                <div><span style={{'font-weight':'800','color':'#344050'}}>{data.account_number}</span> - <span style={{'font-weight':'800','color':'#344050'}}>{data.account_name}</span></div>
                                                <div>{data.address.line_1}</div>
                                                {data.address.line_2!=''&&<div>{data.address.line_2}</div>}
                                                {data.address.line_3!=''&&<div>{data.address.line_3}</div>}
                                              </Table.Cell>
                                            </Table.Row>
                                          })}
                                        </Table.Body>
                                    </Table>}
                                </div>
                            </div>
                            {/*-----------------------------------------------------
                              SEARCH PANEL For Customer: End Script
                            -----------------------------------------------------*/}


                           {/*-----------------------------------------------------
                              SEARCH PANEL For Product
                          -----------------------------------------------------*/}
                           <div className="search_Panel">
                                  <div className="search_Panelbody">

                                      <Form.Group widths="equal">
                                          <Field name="search_product">
                                              {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <Input {...field} onChange={handleChange} placeholder="Search product"/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                              )}
                                          </Field>
                                          <Field name="button_param">
                                            {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <Button className='LightGrayButton strong' size='medium' content='Search'  icon='search icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                      SearchProductFunction(values.search_product)
                                                  }}/>
                                                </Form.Field>
                                              )}
                                          </Field>
                                      </Form.Group>



                                      {(dataProduct.length==0&&searchProduct)&&<div class="alert-message left error" style={{'margin-bottom':'15px'}}>
                                          <div><i class="info circle icon"></i></div>
                                          <div>
                                            <h3 style={{'font-weight':'700'}}>Search result</h3>
                                            <p>(0) result found. Try your search again.</p>
                                          </div>
                                      </div>}

                                      {(dataProduct.length>0&&!hideAlert2)&&<div class="alert-message left" style={{'margin-bottom':'15px', 'background-color':'#fcfff5', 'color':'#2c662d'}}>
                                        <div>
                                          <h3 style={{'font-weight':'700','color':'#2c662d'}}>({dataProduct.length}) result{dataProduct.length>1?"'s":''} found</h3>
                                        </div>
                                      </div>}


                                      {dataProduct.length>0&&<Table celled compact='very'>
                                        <Table.Header>
                                          <Table.Row verticalAlign='middle'>
                                            <Table.HeaderCell colSpan='2' collapsing style={{'font-weight':'700','background-color':'#f9fafb','color':'#573a08'}}>
                                              <p>Select Product</p>
                                              {values.product_id==0&&<div class="alert-message left error">
                                              <div>
                                                <h3 style={{'color':'#9f3a38', 'font-size':'12px'}}>This field is required.</h3>
                                              </div>
                                            </div>}
                                            </Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                        {dataProduct.map(function(data, key){
                                            return <Table.Row verticalAlign='middle' positive={data.id==values.product_id} onClick={()=>{
                                                    setFieldValue('product_id',data.id);
                                                }}>
                                                <Table.Cell style={{'cursor':'pointer','width':'1%'}} collapsing>
                                                  {data.id==values.product_id&&values.product_id!=0&&<i className='uil-check icon' style={{'color':'#21ba45'}}></i>}
                                                </Table.Cell>
                                                <Table.Cell style={{'cursor':'pointer'}} collapsing>
                                                  <div style={{'font-weight':'800','color':'#344050'}}>{data.code}</div>
                                                  <div>{data.name}</div>
                                                </Table.Cell>
                                              </Table.Row>
                                            })}
                                          </Table.Body>
                                      </Table>}
                                  </div>
                              </div>
                              {/*-----------------------------------------------------
                                SEARCH PANEL For Product: End Script
                              -----------------------------------------------------*/}

                              <Form.Group widths="equal">
                                <Field name="quantity">
                                    {({ field, form }) => (
                                    <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <label>Quantity</label>
                                      <Cleave {...field} onChange={handleChange} options={{numericOnly: true}}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                    )}
                                </Field>
                              </Form.Group>

                              <p style={{'font-weight':'700','margin-bottom':'10px'}}>Applied processing notes:</p>

                              <Form.Group widths="equal">
                                <Field name="price">
                                    {({ field, form }) => (
                                    <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <label>Price</label>
                                      <Cleave {...field}
                                            onChange={event => {
                                              setFieldValue('price',event.target.rawValue);
                                          }} options={{numeral: true, numeralThousandsGroupStyle: 'thousand', prefix:CurrencySymbol()+' ', rawValueTrimPrefix: true}}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                    )}
                                </Field>
                              </Form.Group>

                       
                              <Form.Group widths="equal">
                                <Field name="carriage">
                                      {({ field, form }) => (
                                      <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                        <label>Carriage</label>
                                        <Input {...field} onChange={handleChange} placeholder="optional"/>
                                        { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                      </Form.Field>
                                      )}
                                </Field>
                              </Form.Group>

                              <Form.Group widths="equal">
                                <Field name="handling_fee">
                                      {({ field, form }) => (
                                      <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                        <label>Handling Fee</label>
                                        <Input {...field} onChange={handleChange} placeholder="optional"/>
                                        { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                      </Form.Field>
                                      )}
                                </Field>
                              </Form.Group>

                              <Form.Group widths="equal">
                                <Field name="note">
                                    {({ field, form }) => (
                                    <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <label>Note</label>
                                      <TextArea {...field} onChange={handleChange}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                    )}
                                </Field>
                              </Form.Group>

                          </div>
                          {/* left column .page-form-body end*/}


                          <div className="page-form-footer">
                                <Button disabled={spinner||authPages['adding']==0} className='PrimaryButton strong' size='small' content='Save Custom Note' icon='save icon' onClick={() => {
                 
                                  if(values.customer_id==values.current_data.customer_id&&
                                    values.product_id==values.current_data.product_id&&
                                    values.quantity==values.current_data.quantity&&
                                    values.price==values.current_data.price&&
                                    values.carriage==values.current_data.carriage&&
                                    values.handling_fee==values.current_data.handling_fee&&
                                    values.note==values.current_data.note){
                                      setnofitycontent({intent:'warning',settings:{onclose:true,reload:false,title:'Waning Message',text:'The saving process will not proceed. No changes were made to existing data.'}});
                                      setnotify(true);
                                      return false;
                                  }
                                  
                                  buttonSubmit(1)

                                }}/>
                                <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                          </div>



                       </div>
                       {/* left column .page-form-panel end*/}

                      </div>
                      {/* left column end*/}


                      {/* right column*/}
                      {values.version_data.length>0&&<div>

                          <div className="page-form-panel">
                            <div className="page-form-header"><h3>Version History</h3></div>
                            <div className="page-form-body">

                              <EditHistoryNotesComponent data_id={params.id}/>

                            </div>
                          </div>

                      </div>}
                      {/* right column end*/}

                  </div>
                  {/* .layout-one-column end */}

                </div>
                {/*.app-body-wrapper end*/}
                {/*.page-wrapper-full/.page-wrapper-half end*/}
              </div>
              )}}
            </Formik>
         </Form>
          
      </React.Fragment>}
    </React.Fragment>
  )
}
